import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/site/change-deal-status";
const apiRemoveEndpoint = API_BASE_URL_ENV() + "/admin/crm/deal-status-update";
 
 
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    changeStatus=(id,status)=>{
        return http.get(`${apiEndpoint}/${id}/${status}`)
    }

    changeRemovedStatus=(params)=>{
        return http.post(apiRemoveEndpoint, params)
    }
}
